import React from 'react';
import logo from './logo.svg';
import './App.css';
import Button1 from './components/main';

function App() {
  return (
    <div className="App">
     <Button1 />
    </div>
  );
}

export default App;
